import * as React from 'react';
import { Logging } from '../..';
import UrlExtractor from './UrlExtractor';

export interface s3UploadResponse {
  file: File,
  url: string;
  s3File: s3UploadFile;
  status: number;
  responseText: string;
}

export interface s3UploadFile {
  name: string;
  type: string;
  size: number;
  data: string | ArrayBuffer;
}

export interface s3UploadProperties {
  file: File,
  url: string;
  s3File: s3UploadFile;
  setUploadProgress: (s3File: s3UploadFile, progress: number, fileBytesUploaded: number, fileBytesToUpload: number) => void;
  setUploadResponse: (response: s3UploadResponse) => void;
}

export function uploadS3WithPresignedUrl({
  file,
  url,
  s3File,
  setUploadProgress,
  setUploadResponse,
}: s3UploadProperties): void {
  Logging.Debug('S3 Upload:', s3File.name, s3File.type, s3File.size, url);

  const request = new XMLHttpRequest();
  request.open('PUT', url, true);
  request.setRequestHeader('Content-Type', s3File.type);
  request.onerror = () => {
    setUploadResponse({
      file,
      url,
      s3File,
      status: 403,
      responseText: `Error Uploading file '${s3File.name}' to Server.`,
    });
  };
  request.onreadystatechange = () => {
    if (request.readyState === XMLHttpRequest.DONE) {
      // Success
      if (request.status === 200) {
        setUploadResponse({
          file,
          url,
          s3File,
          status: 200,
          responseText: new UrlExtractor().extractFileLocationFromPresignedUrl(url),
        });
      } else if (request.status !== 200) {
        setUploadResponse({
          file,
          url,
          s3File,
          status: request.status,
          responseText: `Error Uploading file '${s3File.name}' to Server.`,
        });
      }
    }
  };
  request.upload.onprogress = (event) => {
    if (event.lengthComputable) {
      const progress = Math.round((event.loaded / event.total) * 100);
      setUploadProgress(s3File, progress, event.loaded, event.total);
    }
  };
  request.send(s3File.data);
}
